export const servicesGraphVideoSource =
	"/assets/memorang-animated-services-graph.mp4";
export const servicesGraphVideoType = "video/mp4";

export const ailaVideoSource = "/assets/memorang-aila.mp4";
export const ailaVideoType = "video/mp4";
